module.exports = __webpack_public_path__ + "img/category.9a3409d2.svg";